import React, { useState } from 'react';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import { makeStyles } from '@mui/styles';
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  IconButton,
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Box,
  useMediaQuery,
} from '@mui/material';
import { Menu as MenuIcon, Close as CloseIcon } from '@mui/icons-material';

const useStyles = makeStyles((theme) => ({
  appBar: {
    position: 'fixed',
    zIndex: theme.zIndex.drawer + 1,
  },
  toolbar: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  logo: {
    fontWeight: 700,
    textDecoration: 'none',
    color: theme.palette.text.primary,
  },
  navLinks: {
    display: 'flex',
    gap: theme.spacing(1),
  },
  navButton: {
    color: theme.palette.text.primary,
    fontWeight: 500,
    '&:hover': {
      backgroundColor: theme.palette.action.hover,
    },
  },
  activeNavButton: {
    color: theme.palette.secondary.main,
    fontWeight: 600,
  },
  drawer: {
    '& .MuiDrawer-paper': {
      width: 250,
      paddingTop: theme.spacing(2),
    },
  },
  drawerHeader: {
    display: 'flex',
    justifyContent: 'flex-end',
    padding: theme.spacing(0, 1),
  },
}));

const navItems = [
  { label: 'Home', path: '/' },
  { label: 'Projects', path: '/projects' },
  { label: 'Blog', path: '/blog' },
  { label: 'Contact', path: '/contact' },
];

const Navbar = () => {
  const classes = useStyles();
  const [drawerOpen, setDrawerOpen] = useState(false);
  const location = useLocation();
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down('md'));

  const isActive = (path) => {
    if (path === '/') return location.pathname === '/';
    return location.pathname.startsWith(path);
  };

  return (
    <AppBar className={classes.appBar} color="default" elevation={0}>
      <Toolbar className={classes.toolbar}>
        <Typography
          variant="h6"
          component={RouterLink}
          to="/"
          className={classes.logo}
        >
          Ameet Toor
        </Typography>

        {isMobile ? (
          <>
            <IconButton
              edge="end"
              aria-label="open menu"
              onClick={() => setDrawerOpen(true)}
            >
              <MenuIcon />
            </IconButton>
            <Drawer
              anchor="right"
              open={drawerOpen}
              onClose={() => setDrawerOpen(false)}
              className={classes.drawer}
            >
              <Box className={classes.drawerHeader}>
                <IconButton
                  aria-label="close menu"
                  onClick={() => setDrawerOpen(false)}
                >
                  <CloseIcon />
                </IconButton>
              </Box>
              <List>
                {navItems.map((item) => (
                  <ListItem key={item.label} disablePadding>
                    <ListItemButton
                      component={RouterLink}
                      to={item.path}
                      onClick={() => setDrawerOpen(false)}
                      selected={isActive(item.path)}
                    >
                      <ListItemText primary={item.label} />
                    </ListItemButton>
                  </ListItem>
                ))}
              </List>
            </Drawer>
          </>
        ) : (
          <Box className={classes.navLinks}>
            {navItems.map((item) => (
              <Button
                key={item.label}
                component={RouterLink}
                to={item.path}
                className={`${classes.navButton} ${isActive(item.path) ? classes.activeNavButton : ''}`}
              >
                {item.label}
              </Button>
            ))}
          </Box>
        )}
      </Toolbar>
    </AppBar>
  );
};

export default Navbar;
